import { t } from '../../i18n/i18n';
import { store, useApp } from '../../state/store';
import { IconFit, IconZoomIn, IconZoomOut } from '../icons';
import { REAL_SIZE_ZOOM, ZOOM_STEP, zoomAt, zoomPercent } from './zoom';

/** Zoom buttons for a stage element (zooms around the stage centre). */
export function ZoomControls({ stage, onFit }: { stage: () => HTMLElement | null; onFit: () => void }) {
  const zoom = useApp((s) => s.viewport.zoom);
  const zoomBy = (f: number) => {
    const el = stage();
    const w = el?.clientWidth ?? 800, h = el?.clientHeight ?? 600;
    store.set((s) => ({ viewport: zoomAt(s.viewport, f, w / 2, h / 2) }));
  };
  return (
    <div className="zoom-controls" role="group" aria-label={t('Zoom')}>
      <button className="btn small icon" aria-label={t('Zoom out (−)')} title={t('Zoom out (−)')} onClick={() => zoomBy(1 / ZOOM_STEP)}>
        <IconZoomOut size={14} />
      </button>
      <button
        className="btn small"
        aria-label={t('Show at actual size')}
        title={t('Click for actual size (100 %)')}
        onClick={() => zoomBy(REAL_SIZE_ZOOM / zoom)}
        style={{ minWidth: 56, justifyContent: 'center', fontFamily: 'var(--mono)' }}
      >
        {zoomPercent(zoom)} %
      </button>
      <button className="btn small icon" aria-label={t('Zoom in (+)')} title={t('Zoom in (+)')} onClick={() => zoomBy(ZOOM_STEP)}>
        <IconZoomIn size={14} />
      </button>
      <button className="btn small icon" aria-label={t('Fit to window (F)')} title={t('Fit to window (F)')} onClick={onFit}>
        <IconFit size={14} />
      </button>
    </div>
  );
}
